import React from 'react';
import PropTypes from 'prop-types';
import TickComponent from '../icons/tick/TickComponent';

import './Checkbox.scss';

/**
 * Common Moo style checkbox that can be extended
 */

class CheckboxComponent extends React.Component {
  static defaultProps: {};

  constructor(props: {}) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e): void {
    e.stopPropagation();
    if (e.type === 'click') {
      document.querySelectorAll('body')[0].focus();
      if (this.props.isChecked) {
        this.props.onDeselect(this.props.value);
      } else {
        this.props.onSelect(this.props.value);
      }
    }
  }

  render() {
    const checked = this.props.isChecked ? 'checkbox-component__tick--active' : '';
    const { isChecked } = this.props;

    let statusClass = '';
    if (isChecked) {
      statusClass = 'checked';
    } else {
      statusClass = 'show';
    }

    return (
      <div className={`checkbox-component ${statusClass}`} onClick={this.handleClick} onTouchEnd={this.handleClick}>
        <div className="checkbox-component__wrapper">
          <input type="checkbox" id={this.props.value} />
          <label htmlFor={this.props.value}>
            <span />
          </label>
          <span className={`checkbox-component__tick ${checked}`}>
            <TickComponent />
          </span>
        </div>
      </div>
    );
  }
}

CheckboxComponent.displayName = 'Checkbox';

CheckboxComponent.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  value: PropTypes.string.isRequired,
  onSelect: PropTypes.func,
  onDeselect: PropTypes.func,
};

CheckboxComponent.defaultProps = {
  onSelect() {},
  onDeselect() {},
};

export default CheckboxComponent;
